import { render, staticRenderFns } from "./AiReportingChatModal.vue?vue&type=template&id=17845615&scoped=true&"
import script from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChatModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChatModal.vue?vue&type=style&index=0&id=17845615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17845615",
  null
  
)

export default component.exports